import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { TokenService } from '../services/token.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

let alertShown = false;
export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const tokenService = inject(TokenService);
  const router = inject(Router);

  if (typeof window !== 'undefined') {
    const token = tokenService.getToken();
    const isLogin = req.url.includes('/login');

    if (token && !isLogin) {
      const clonedRequest = req.clone({
        setHeaders: { Authorization: `Bearer ${token}` },
      });

      return next(clonedRequest).pipe(
        catchError((error) => handleAuthError(error, router, tokenService))
      );
    }
  }

  return next(req).pipe(
    catchError((error) => handleAuthError(error, router, tokenService))
  );
};

function handleAuthError(
  error: any,
  router: Router,
  tokenService: TokenService
) {
  if (error.error?.message === 'Acceso denegado') {
    if (!alertShown) {
      alert('Se accedió a la cuenta desde otro dispositivo');
      alertShown = true;
    }

    tokenService.removeToken();
    if (typeof window !== 'undefined') {
      localStorage.clear();
    }

    router.navigate(['/login']);
  }
  return throwError(() => error);
}
